import React from 'react'

import { arrayOf, bool, shape, string } from 'prop-types'

function CategoriesTable({ categories, hidden = false }) {
  const wrapperClass = hidden
    ? 'asset-collection__subcategories asset-collection__subcategories--hidden'
    : 'asset-collection__subcategories'

  return (
    <div className={wrapperClass} aria-hidden={hidden} inert={hidden ? "" : undefined}>
      <div className="subcategories-table">
        <div className="subcategories-table__row">
          {categories?.map((category, index) => {

            return (
              <div className="subcategories-table__column" key={index}>
                <div className="subcategories-table__header">
                  <a
                    href={category.path}
                    className="subcategories-table__title"
                  >
                    {category.title}
                  </a>
                  <span className="subcategories-table__count">
                    {category.itemCount}
                  </span>
                </div>
                <ul className="subcategories-table__list">
                  {category.subcategories.map((subcat, subIndex) => (
                    <li key={subIndex} className="subcategories-table__item">
                      <a
                        href={subcat.path}
                        className="subcategories-table__link"
                      >
                        {subcat.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

CategoriesTable.propTypes = {
  categories: arrayOf(
    shape({
      title: string.isRequired,
      itemCount: string,
      productType: string,
      slug: string,
      subcategories: arrayOf(shape({ title: string, slug: string, path: string })),
    })
  ).isRequired,
  hidden: bool,
}

export default CategoriesTable
